// extracted by mini-css-extract-plugin
export default {"header1":"Header1-module--header1--jgHCb","header1--center":"Header1-module--header1--center--Tj9QB"};